import { Vec3 } from "@/src/utils/vector";
import { Phase } from "./Walkthrough";
import { commentary, IWalkthroughArgs, setInitialCamera } from "./WalkthroughTools";

export function walkthrough05_Softmax(args: IWalkthroughArgs) {
    let { walkthrough: wt, state } = args;

    if (wt.phase !== Phase.Input_Detail_Softmax) {
        return;
    }

    setInitialCamera(state, new Vec3(-24.350, 0.000, -1702.195), new Vec3(283.100, 0.600, 1.556));

    let c0 = commentary(wt, null, 0)`Softmax 用于自注意力，也用于模型的最终输出。它把一组分数转换为总和等于 1 的概率。

不是直接除以数值之和，而是先对每个输入取指数：

  a = exp(x_1)

指数结果均为正数，再将每个结果除以全部指数结果的总和。最终各数值介于 0 和 1 之间，总和为 1，构成概率分布。

如果输入很大，指数结果可能溢出。Softmax 有一个有用性质：给全部输入加上或减去同一个常数，不会改变结果。因此实际计算先减去输入中的最大值，使最大值变为 0，改善数值稳定性。

在自注意力中，每次处理注意力矩阵的一行，且只使用对角线及其之前的部分，避免访问未来。

与层归一化类似，我们先保存每一行的最大值，以及减去最大值后各指数结果的总和。输出时只需执行减最大值、取指数、除以总和这三步。

为什么叫“软最大值”？硬选择会选出最大项，把对应位置设为 1，其余位置设为 0。Softmax 则保留整个概率分布，同时通过指数运算突出较大的分数。这既体现最可能的选项，也保留其他选项的相对可能性。`;

}
